export default "__VITE_ASSET__C9V$xZNR__"